import { render, staticRenderFns } from "./ArticleSection.vue?vue&type=template&id=04f45ba9&scoped=true"
import script from "./ArticleSection.vue?vue&type=script&lang=js"
export * from "./ArticleSection.vue?vue&type=script&lang=js"
import style0 from "./ArticleSection.vue?vue&type=style&index=0&id=04f45ba9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f45ba9",
  null
  
)

export default component.exports